import { Grid, Slide } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';
import { createPortal } from 'react-dom';
import { Text } from '../react-components/Text';

interface ActionsFastActionsMenuProps {
  intlId: string;
  onClick: () => void;
  textStyles?: React.CSSProperties;
  icon?: React.ReactNode;
  styles?: React.CSSProperties;
}

interface FastActionsMenuProps {
  openMenu: boolean;
  zIndex?: number;
  setOpenMenu: (openMenu: boolean) => void;
  actions?: Array<ActionsFastActionsMenuProps | null>;
  portalElementId?: string;
}

export const FastActionsMenu = ({
  openMenu,
  zIndex = 1005,
  setOpenMenu,
  actions,
  portalElementId,
}: FastActionsMenuProps) => {
  if (!openMenu) {
    return null;
  }

  const content = (
    <>
      <div
        style={{
          zIndex,
          position: `absolute`,
          top: `0`,
          left: `0`,
          height: `100%`,
          width: `100%`,
          backgroundColor: RoutalPalette.backgroundPrimary,
        }}
        className="animate__animated animate__fadeIn"
      />

      <Slide
        key="fas-actions-menu"
        in={openMenu}
        direction="up"
        mountOnEnter
        unmountOnExit
        timeout={{ enter: 400, exit: 300 }}
        style={{
          zIndex,
          position: `absolute`,
          top: `0`,
          left: `0`,
          height: `100%`,
          width: `100%`,
          display: `flex`,
          alignItems: `center`,
          justifyContent: `center`,
        }}
      >
        <Grid
          container
          style={{
            height: `100%`,
            width: `100%`,
            justifyContent: `flex-end`,
            display: `flex`,
            alignItems: `center`,
            flexDirection: `column`,
            alignSelf: `center`,
            padding: `12px 24px`,
          }}
          onClick={() => {
            setOpenMenu(false);
          }}
        >
          {actions?.map((action, index, array) => {
            if (action === null) {
              return <div key={`fast-action-menu-${index}`} style={{ height: `10px` }} />;
            }

            const borderTopRadius = index === 0 || array[index - 1] === null;
            const borderBottomRadius = index === array.length - 1 || array[index + 1] === null;

            return (
              <Grid
                key={`fast-action-menu-${index}`}
                container
                style={{
                  backgroundColor: RoutalPalette.white,
                  borderTopLeftRadius: borderTopRadius ? `10px` : `0px`,
                  borderTopRightRadius: borderTopRadius ? `10px` : `0px`,
                  borderBottomLeftRadius: borderBottomRadius ? `10px` : `0px`,
                  borderBottomRightRadius: borderBottomRadius ? `10px` : `0px`,
                  borderTop: index !== 0 ? `1px solid ${RoutalPalette.neutral10}` : undefined,
                  borderBottom: index !== actions.length ? `1px solid ${RoutalPalette.neutral10}` : undefined,
                  height: `52px`,
                  width: `100%`,
                  display: `flex`,
                  justifyContent: `center`,
                  alignItems: `center`,
                  ...action.styles,
                }}
                onClick={() => {
                  action.onClick();
                }}
              >
                <Grid
                  item
                  style={{
                    width: `100%`,
                    display: `flex`,
                    justifyContent: `center`,
                    alignItems: `center`,
                  }}
                  gap="6px"
                >
                  {action.icon}
                  <Text variant="button" style={action.textStyles} intlId={action.intlId} />
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Slide>
    </>
  );

  const element = document.getElementById(portalElementId ?? ``);
  if (element) {
    return createPortal(content, element as HTMLElement);
  }

  return content;
};
